import { Typography } from '@material-tailwind/react'

const ImageFigureContent = ({ image }) => {
// const ImageFigureContent = ({ image, title, description }) => {
    return (
        <>
            <figure className="relative h-auto w-full">
                <img
                    className="h-full w-full rounded-xl object-cover object-center"
                    src={image}
                    alt="under_construction_image"
                />
                {/* <figcaption className="absolute bottom-8 left-2/4 flex w-[calc(100%-4rem)] -translate-x-2/4 justify-between rounded-xl border border-white bg-white/75 py-4 px-6 shadow-lg shadow-black/5 saturate-200 backdrop-blur-md"> */}
                {/* <div>
                        <Typography variant="h5" color="blue-gray">
                            {title}
                        </Typography>
                        <Typography color="gray" className="mt-2 font-normal">
                            {description}

                        </Typography>
                    </div> */}
                {/* <Typography variant="h5" color="blue-gray">
                                    Growth
                                </Typography> */}
                {/* </figcaption> */}
            </figure>
        </>
    )
}

export default ImageFigureContent